import { useMutation, useQueryClient } from '@tanstack/react-query';
import { approvePcmpProposalMarketing } from '../api/pcmpProposals.api';
import type { PcmpMktApprovalKind, PcmpMktApprovePayload } from '../types/pcmpProposal.types';
import { pcmpActionCallbacks } from '../utils/pcmpActionCallbacks';

export function useApprovePcmpProposal(
  proposalId: number,
  kind: PcmpMktApprovalKind,
  onSuccess: () => void,
) {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (payload: PcmpMktApprovePayload) =>
      approvePcmpProposalMarketing(proposalId, payload),
    ...pcmpActionCallbacks(
      queryClient,
      kind === 'ENDORSE' ? 'Endorsement recorded' : 'Proposal approved',
      onSuccess,
    ),
  });
}
